<template>
    <ion-alert
        :is-open="isOpenRef"
        ref="alert"
        :header="header"
        :sub-header="subtitle"
        :message="message"
        :buttons="buttons"
        @onDidDismiss="dismissed()"
    ></ion-alert>
</template>

<script>
import {IonAlert} from '@ionic/vue';
import _ from 'lodash';
import {ref} from 'vue';
import router from "@/router";
export default {
    inject: [],
    props: ['subtitle', 'header', 'offerJumpToCheck', 'offerJumpToPack', 'shipment'],
    name: "PeopleAssignedToShipmentAlert",
    components: {IonAlert},
    computed: {
        buttons() {
            const buttons = [];
            if (this.offerJumpToCheck) {
                buttons.push({
                    text: 'Jump to Check',
                    handler: () => {
                        console.log(this.shipment);
                        router.push({name: 'checks.check.lines', params: {shipment: this.shipment.id}});
                    }
                });
            }
            if (this.offerJumpToPack) {
                buttons.push({
                    text: 'Jump to Pack',
                    handler: () => {
                        router.push({name: 'packs.pack', params: {id: this.shipment.id}});
                    }
                });
            }
            buttons.push({
                text: 'Ok',
                role: 'cancel'
            });
            return buttons;
        },
        message() {
            return _(this.users).map(user => {
                let string = user.name;
                if (user.pivot && user.pivot.accepted_at) {
                    string += ' <small>(accepted at: ' + user.pivot.accepted_at + ')</small>';
                }
                return string + '<br />';
            }).join('');
        }
    },
    methods: {
        dismissed() {
            this.setOpen(false);
        },
        open(users) {
            this.users = users;
            this.setOpen(true);
        }
    },
    data() {
        return {
            users: []
        }
    },
    setup() {
        const isOpenRef = ref(false);
        const setOpen = (state) => isOpenRef.value = state;
        return {
            isOpenRef, setOpen
        }
    }
}
</script>
